import axios from 'axios';
import CONFIG from '../config';

export const getToolContent = () => axios.get(`${CONFIG.API_BASE}/xapi/content/get/tools`).then(res => res.data);
